// extracted by mini-css-extract-plugin
export var errorsContainer = "_t7-1";
export var link = "_t7-0";